import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ViewContainerRef, Component, Attribute, Optional, SkipSelf, ViewChild, ChangeDetectionStrategy, Directive, ContentChild, ContentChildren, inject, Injector, EnvironmentInjector, Injectable, makeEnvironmentProviders, APP_INITIALIZER, forwardRef, HostListener } from '@angular/core';
import * as i2$1 from '@ionic/angular/common';
import { IonRouterOutlet as IonRouterOutlet$1, ProxyCmp as ProxyCmp$1, IonBackButton as IonBackButton$1, IonModal as IonModal$1, IonPopover as IonPopover$1, RouterLinkDelegateDirective, RouterLinkWithHrefDelegateDirective, IonTabs as IonTabs$1, OverlayBaseController, AngularDelegate, ConfigToken, provideComponentInputBinding, MenuController as MenuController$1, IonNav as IonNav$1, ValueAccessor, setIonicClasses } from '@ionic/angular/common';
const _c0 = ["outletContent"];
const _c1 = ["*"];
function IonModal_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementContainer(1, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template);
  }
}
function IonPopover_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template);
  }
}
const _c2 = ["outlet"];
const _c3 = [[["", "slot", "top"]], "*", [["ion-tab"]]];
const _c4 = ["[slot=top]", "*", "ion-tab"];
function IonTabs_ion_router_outlet_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ion-router-outlet", 5, 1);
    i0.ɵɵlistener("stackWillChange", function IonTabs_ion_router_outlet_3_Template_ion_router_outlet_stackWillChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onStackWillChange($event));
    })("stackDidChange", function IonTabs_ion_router_outlet_3_Template_ion_router_outlet_stackDidChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onStackDidChange($event));
    });
    i0.ɵɵelementEnd();
  }
}
function IonTabs_ng_content_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 2, ["*ngIf", "tabs.length > 0"]);
  }
}
export { Config, DomController, IonModalToken, IonicRouteStrategy, NavController, NavParams, Platform } from '@ionic/angular/common';
import { defineCustomElement as defineCustomElement$2 } from '@ionic/core/components/ion-back-button.js';
import { defineCustomElement as defineCustomElement$1 } from '@ionic/core/components/ion-router-outlet.js';
import * as i1 from '@angular/common';
import { CommonModule, NgIf, DOCUMENT } from '@angular/common';
import * as i2 from '@angular/router';
import { defineCustomElement as defineCustomElement$3 } from '@ionic/core/components/ion-modal.js';
import { defineCustomElement as defineCustomElement$4 } from '@ionic/core/components/ion-popover.js';
import { fromEvent } from 'rxjs';
import { defineCustomElement as defineCustomElement$5 } from '@ionic/core/components/ion-accordion.js';
import { defineCustomElement as defineCustomElement$6 } from '@ionic/core/components/ion-accordion-group.js';
import { defineCustomElement as defineCustomElement$7 } from '@ionic/core/components/ion-action-sheet.js';
import { defineCustomElement as defineCustomElement$8 } from '@ionic/core/components/ion-alert.js';
import { defineCustomElement as defineCustomElement$9 } from '@ionic/core/components/ion-app.js';
import { defineCustomElement as defineCustomElement$a } from '@ionic/core/components/ion-avatar.js';
import { defineCustomElement as defineCustomElement$b } from '@ionic/core/components/ion-backdrop.js';
import { defineCustomElement as defineCustomElement$c } from '@ionic/core/components/ion-badge.js';
import { defineCustomElement as defineCustomElement$d } from '@ionic/core/components/ion-breadcrumb.js';
import { defineCustomElement as defineCustomElement$e } from '@ionic/core/components/ion-breadcrumbs.js';
import { defineCustomElement as defineCustomElement$f } from '@ionic/core/components/ion-button.js';
import { defineCustomElement as defineCustomElement$g } from '@ionic/core/components/ion-buttons.js';
import { defineCustomElement as defineCustomElement$h } from '@ionic/core/components/ion-card.js';
import { defineCustomElement as defineCustomElement$i } from '@ionic/core/components/ion-card-content.js';
import { defineCustomElement as defineCustomElement$j } from '@ionic/core/components/ion-card-header.js';
import { defineCustomElement as defineCustomElement$k } from '@ionic/core/components/ion-card-subtitle.js';
import { defineCustomElement as defineCustomElement$l } from '@ionic/core/components/ion-card-title.js';
import { defineCustomElement as defineCustomElement$m } from '@ionic/core/components/ion-chip.js';
import { defineCustomElement as defineCustomElement$n } from '@ionic/core/components/ion-col.js';
import { defineCustomElement as defineCustomElement$o } from '@ionic/core/components/ion-content.js';
import { defineCustomElement as defineCustomElement$p } from '@ionic/core/components/ion-datetime-button.js';
import { defineCustomElement as defineCustomElement$q } from '@ionic/core/components/ion-fab.js';
import { defineCustomElement as defineCustomElement$r } from '@ionic/core/components/ion-fab-button.js';
import { defineCustomElement as defineCustomElement$s } from '@ionic/core/components/ion-fab-list.js';
import { defineCustomElement as defineCustomElement$t } from '@ionic/core/components/ion-footer.js';
import { defineCustomElement as defineCustomElement$u } from '@ionic/core/components/ion-grid.js';
import { defineCustomElement as defineCustomElement$v } from '@ionic/core/components/ion-header.js';
import { defineCustomElement as defineCustomElement$w } from '@ionic/core/components/ion-img.js';
import { defineCustomElement as defineCustomElement$x } from '@ionic/core/components/ion-infinite-scroll.js';
import { defineCustomElement as defineCustomElement$y } from '@ionic/core/components/ion-infinite-scroll-content.js';
import { defineCustomElement as defineCustomElement$z } from '@ionic/core/components/ion-input-password-toggle.js';
import { defineCustomElement as defineCustomElement$A } from '@ionic/core/components/ion-item.js';
import { defineCustomElement as defineCustomElement$B } from '@ionic/core/components/ion-item-divider.js';
import { defineCustomElement as defineCustomElement$C } from '@ionic/core/components/ion-item-group.js';
import { defineCustomElement as defineCustomElement$D } from '@ionic/core/components/ion-item-option.js';
import { defineCustomElement as defineCustomElement$E } from '@ionic/core/components/ion-item-options.js';
import { defineCustomElement as defineCustomElement$F } from '@ionic/core/components/ion-item-sliding.js';
import { defineCustomElement as defineCustomElement$G } from '@ionic/core/components/ion-label.js';
import { defineCustomElement as defineCustomElement$H } from '@ionic/core/components/ion-list.js';
import { defineCustomElement as defineCustomElement$I } from '@ionic/core/components/ion-list-header.js';
import { defineCustomElement as defineCustomElement$J } from '@ionic/core/components/ion-loading.js';
import { defineCustomElement as defineCustomElement$K } from '@ionic/core/components/ion-menu.js';
import { defineCustomElement as defineCustomElement$L } from '@ionic/core/components/ion-menu-button.js';
import { defineCustomElement as defineCustomElement$M } from '@ionic/core/components/ion-menu-toggle.js';
import { defineCustomElement as defineCustomElement$N } from '@ionic/core/components/ion-nav-link.js';
import { defineCustomElement as defineCustomElement$O } from '@ionic/core/components/ion-note.js';
import { defineCustomElement as defineCustomElement$P } from '@ionic/core/components/ion-picker.js';
import { defineCustomElement as defineCustomElement$Q } from '@ionic/core/components/ion-picker-column.js';
import { defineCustomElement as defineCustomElement$R } from '@ionic/core/components/ion-picker-column-option.js';
import { defineCustomElement as defineCustomElement$S } from '@ionic/core/components/ion-picker-legacy.js';
import { defineCustomElement as defineCustomElement$T } from '@ionic/core/components/ion-progress-bar.js';
import { defineCustomElement as defineCustomElement$U } from '@ionic/core/components/ion-radio.js';
import { defineCustomElement as defineCustomElement$V } from '@ionic/core/components/ion-refresher.js';
import { defineCustomElement as defineCustomElement$W } from '@ionic/core/components/ion-refresher-content.js';
import { defineCustomElement as defineCustomElement$X } from '@ionic/core/components/ion-reorder.js';
import { defineCustomElement as defineCustomElement$Y } from '@ionic/core/components/ion-reorder-group.js';
import { defineCustomElement as defineCustomElement$Z } from '@ionic/core/components/ion-ripple-effect.js';
import { defineCustomElement as defineCustomElement$_ } from '@ionic/core/components/ion-row.js';
import { defineCustomElement as defineCustomElement$$ } from '@ionic/core/components/ion-segment-button.js';
import { defineCustomElement as defineCustomElement$10 } from '@ionic/core/components/ion-segment-content.js';
import { defineCustomElement as defineCustomElement$11 } from '@ionic/core/components/ion-segment-view.js';
import { defineCustomElement as defineCustomElement$12 } from '@ionic/core/components/ion-select-modal.js';
import { defineCustomElement as defineCustomElement$13 } from '@ionic/core/components/ion-select-option.js';
import { defineCustomElement as defineCustomElement$14 } from '@ionic/core/components/ion-skeleton-text.js';
import { defineCustomElement as defineCustomElement$15 } from '@ionic/core/components/ion-spinner.js';
import { defineCustomElement as defineCustomElement$16 } from '@ionic/core/components/ion-split-pane.js';
import { defineCustomElement as defineCustomElement$17 } from '@ionic/core/components/ion-tab.js';
import { defineCustomElement as defineCustomElement$18 } from '@ionic/core/components/ion-tab-bar.js';
import { defineCustomElement as defineCustomElement$19 } from '@ionic/core/components/ion-tab-button.js';
import { defineCustomElement as defineCustomElement$1a } from '@ionic/core/components/ion-text.js';
import { defineCustomElement as defineCustomElement$1b } from '@ionic/core/components/ion-thumbnail.js';
import { defineCustomElement as defineCustomElement$1c } from '@ionic/core/components/ion-title.js';
import { defineCustomElement as defineCustomElement$1d } from '@ionic/core/components/ion-toast.js';
import { defineCustomElement as defineCustomElement$1e } from '@ionic/core/components/ion-toolbar.js';
import { modalController, popoverController, initialize, actionSheetController, alertController, createAnimation, getTimeGivenProgression, createGesture, loadingController, menuController, pickerController, toastController } from '@ionic/core/components';
export { IonicSafeString, IonicSlides, createAnimation, createGesture, getPlatforms, getTimeGivenProgression, iosTransitionAnimation, isPlatform, mdTransitionAnimation } from '@ionic/core/components';
import { defineCustomElement as defineCustomElement$1f } from '@ionic/core/components/ion-nav.js';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { defineCustomElement as defineCustomElement$1g } from '@ionic/core/components/ion-checkbox.js';
import { defineCustomElement as defineCustomElement$1h } from '@ionic/core/components/ion-datetime.js';
import { defineCustomElement as defineCustomElement$1i } from 'ionicons/components/ion-icon.js';
import { defineCustomElement as defineCustomElement$1j } from '@ionic/core/components/ion-input.js';
import { defineCustomElement as defineCustomElement$1k } from '@ionic/core/components/ion-input-otp.js';
import { defineCustomElement as defineCustomElement$1l } from '@ionic/core/components/ion-radio-group.js';
import { defineCustomElement as defineCustomElement$1m } from '@ionic/core/components/ion-range.js';
import { defineCustomElement as defineCustomElement$1n } from '@ionic/core/components/ion-searchbar.js';
import { defineCustomElement as defineCustomElement$1o } from '@ionic/core/components/ion-segment.js';
import { defineCustomElement as defineCustomElement$1p } from '@ionic/core/components/ion-select.js';
import { defineCustomElement as defineCustomElement$1q } from '@ionic/core/components/ion-textarea.js';
import { defineCustomElement as defineCustomElement$1r } from '@ionic/core/components/ion-toggle.js';
let IonRouterOutlet = /*#__PURE__*/(() => {
  let IonRouterOutlet = class IonRouterOutlet extends IonRouterOutlet$1 {
    parentOutlet;
    /**
     * `static: true` must be set so the query results are resolved
     * before change detection runs. Otherwise, the view container
     * ref will be ion-router-outlet instead of ng-container, and
     * the first view will be added as a sibling of ion-router-outlet
     * instead of a child.
     */
    outletContent;
    /**
     * We need to pass in the correct instance of IonRouterOutlet
     * otherwise parentOutlet will be null in a nested outlet context.
     * This results in APIs such as NavController.pop not working
     * in nested outlets because the parent outlet cannot be found.
     */
    constructor(name, tabs, commonLocation, elementRef, router, zone, activatedRoute, parentOutlet) {
      super(name, tabs, commonLocation, elementRef, router, zone, activatedRoute, parentOutlet);
      this.parentOutlet = parentOutlet;
    }
    /** @nocollapse */
    static ɵfac = function IonRouterOutlet_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRouterOutlet)(i0.ɵɵinjectAttribute('name'), i0.ɵɵinjectAttribute('tabs'), i0.ɵɵdirectiveInject(i1.Location), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(IonRouterOutlet, 12));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRouterOutlet,
      selectors: [["ion-router-outlet"]],
      viewQuery: function IonRouterOutlet_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.outletContent = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 3,
      vars: 0,
      consts: [["outletContent", ""]],
      template: function IonRouterOutlet_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵdomElementContainerStart(0, null, 0);
          i0.ɵɵprojection(2);
          i0.ɵɵdomElementContainerEnd();
        }
      },
      encapsulation: 2
    });
  };
  IonRouterOutlet = __decorate([ProxyCmp$1({
    defineCustomElementFn: defineCustomElement$1
  })], IonRouterOutlet);
  return IonRouterOutlet;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonBackButton = /*#__PURE__*/(() => {
  let IonBackButton = class IonBackButton extends IonBackButton$1 {
    constructor(routerOutlet, navCtrl, config, r, z, c) {
      super(routerOutlet, navCtrl, config, r, z, c);
    }
    /** @nocollapse */
    static ɵfac = function IonBackButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonBackButton)(i0.ɵɵdirectiveInject(IonRouterOutlet, 8), i0.ɵɵdirectiveInject(i2$1.NavController), i0.ɵɵdirectiveInject(i2$1.Config), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonBackButton,
      selectors: [["ion-back-button"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonBackButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonBackButton = __decorate([ProxyCmp$1({
    defineCustomElementFn: defineCustomElement$2
  })], IonBackButton);
  return IonBackButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonModal = /*#__PURE__*/(() => {
  let IonModal = class IonModal extends IonModal$1 {
    /** @nocollapse */static ɵfac = /* @__PURE__ */(() => {
      let ɵIonModal_BaseFactory;
      return function IonModal_Factory(__ngFactoryType__) {
        return (ɵIonModal_BaseFactory || (ɵIonModal_BaseFactory = i0.ɵɵgetInheritedFactory(IonModal)))(__ngFactoryType__ || IonModal);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonModal,
      selectors: [["ion-modal"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [["class", "ion-delegate-host ion-page", 4, "ngIf"], [1, "ion-delegate-host", "ion-page"], [3, "ngTemplateOutlet"]],
      template: function IonModal_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, IonModal_div_0_Template, 2, 1, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isCmpOpen || ctx.keepContentsMounted);
        }
      },
      dependencies: [CommonModule, i1.NgIf, i1.NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonModal = __decorate([ProxyCmp$1({
    defineCustomElementFn: defineCustomElement$3
  })], IonModal);
  return IonModal;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonPopover = /*#__PURE__*/(() => {
  let IonPopover = class IonPopover extends IonPopover$1 {
    /** @nocollapse */static ɵfac = /* @__PURE__ */(() => {
      let ɵIonPopover_BaseFactory;
      return function IonPopover_Factory(__ngFactoryType__) {
        return (ɵIonPopover_BaseFactory || (ɵIonPopover_BaseFactory = i0.ɵɵgetInheritedFactory(IonPopover)))(__ngFactoryType__ || IonPopover);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonPopover,
      selectors: [["ion-popover"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 1,
      vars: 1,
      consts: [[3, "ngTemplateOutlet", 4, "ngIf"], [3, "ngTemplateOutlet"]],
      template: function IonPopover_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, IonPopover_ng_container_0_Template, 1, 1, "ng-container", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", ctx.isCmpOpen || ctx.keepContentsMounted);
        }
      },
      dependencies: [CommonModule, i1.NgIf, i1.NgTemplateOutlet],
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonPopover = __decorate([ProxyCmp$1({
    defineCustomElementFn: defineCustomElement$4
  })], IonPopover);
  return IonPopover;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line @angular-eslint/directive-class-suffix
let IonRouterLink = /*#__PURE__*/(() => {
  class IonRouterLink extends RouterLinkDelegateDirective {
    /** @nocollapse */static ɵfac = /* @__PURE__ */(() => {
      let ɵIonRouterLink_BaseFactory;
      return function IonRouterLink_Factory(__ngFactoryType__) {
        return (ɵIonRouterLink_BaseFactory || (ɵIonRouterLink_BaseFactory = i0.ɵɵgetInheritedFactory(IonRouterLink)))(__ngFactoryType__ || IonRouterLink);
      };
    })();
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: IonRouterLink,
      selectors: [["", "routerLink", "", 5, "a", 5, "area"]],
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return IonRouterLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
// eslint-disable-next-line @angular-eslint/directive-class-suffix
let IonRouterLinkWithHref = /*#__PURE__*/(() => {
  class IonRouterLinkWithHref extends RouterLinkWithHrefDelegateDirective {
    /** @nocollapse */static ɵfac = /* @__PURE__ */(() => {
      let ɵIonRouterLinkWithHref_BaseFactory;
      return function IonRouterLinkWithHref_Factory(__ngFactoryType__) {
        return (ɵIonRouterLinkWithHref_BaseFactory || (ɵIonRouterLinkWithHref_BaseFactory = i0.ɵɵgetInheritedFactory(IonRouterLinkWithHref)))(__ngFactoryType__ || IonRouterLinkWithHref);
      };
    })();
    /** @nocollapse */
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: IonRouterLinkWithHref,
      selectors: [["a", "routerLink", ""], ["area", "routerLink", ""]],
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return IonRouterLinkWithHref;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable */
/* tslint:disable */
const proxyInputs = (Cmp, inputs) => {
  const Prototype = Cmp.prototype;
  inputs.forEach(item => {
    Object.defineProperty(Prototype, item, {
      get() {
        return this.el[item];
      },
      set(val) {
        this.z.runOutsideAngular(() => this.el[item] = val);
      },
      /**
       * In the event that proxyInputs is called
       * multiple times re-defining these inputs
       * will cause an error to be thrown. As a result
       * we set configurable: true to indicate these
       * properties can be changed.
       */
      configurable: true
    });
  });
};
const proxyMethods = (Cmp, methods) => {
  const Prototype = Cmp.prototype;
  methods.forEach(methodName => {
    Prototype[methodName] = function () {
      const args = arguments;
      return this.z.runOutsideAngular(() => this.el[methodName].apply(this.el, args));
    };
  });
};
const proxyOutputs = (instance, el, events) => {
  events.forEach(eventName => instance[eventName] = fromEvent(el, eventName));
};
const defineCustomElement = (tagName, customElement) => {
  if (customElement !== undefined && typeof customElements !== 'undefined' && !customElements.get(tagName)) {
    customElements.define(tagName, customElement);
  }
};
// tslint:disable-next-line: only-arrow-functions
function ProxyCmp(opts) {
  const decorator = function (cls) {
    const {
      defineCustomElementFn,
      inputs,
      methods
    } = opts;
    if (defineCustomElementFn !== undefined) {
      defineCustomElementFn();
    }
    if (inputs) {
      proxyInputs(cls, inputs);
    }
    if (methods) {
      proxyMethods(cls, methods);
    }
    return cls;
  };
  return decorator;
}
let IonAccordion = /*#__PURE__*/(() => {
  let IonAccordion = class IonAccordion {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonAccordion_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonAccordion)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonAccordion,
      selectors: [["ion-accordion"]],
      inputs: {
        disabled: "disabled",
        mode: "mode",
        readonly: "readonly",
        toggleIcon: "toggleIcon",
        toggleIconSlot: "toggleIconSlot",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonAccordion_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonAccordion = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$5,
    inputs: ['disabled', 'mode', 'readonly', 'toggleIcon', 'toggleIconSlot', 'value']
  })], IonAccordion);
  return IonAccordion;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonAccordionGroup = /*#__PURE__*/(() => {
  let IonAccordionGroup = class IonAccordionGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange']);
    }
    /** @nocollapse */
    static ɵfac = function IonAccordionGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonAccordionGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonAccordionGroup,
      selectors: [["ion-accordion-group"]],
      inputs: {
        animated: "animated",
        disabled: "disabled",
        expand: "expand",
        mode: "mode",
        multiple: "multiple",
        readonly: "readonly",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonAccordionGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonAccordionGroup = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$6,
    inputs: ['animated', 'disabled', 'expand', 'mode', 'multiple', 'readonly', 'value']
  })], IonAccordionGroup);
  return IonAccordionGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonActionSheet = /*#__PURE__*/(() => {
  let IonActionSheet = class IonActionSheet {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionActionSheetDidPresent', 'ionActionSheetWillPresent', 'ionActionSheetWillDismiss', 'ionActionSheetDidDismiss', 'didPresent', 'willPresent', 'willDismiss', 'didDismiss']);
    }
    /** @nocollapse */
    static ɵfac = function IonActionSheet_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonActionSheet)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonActionSheet,
      selectors: [["ion-action-sheet"]],
      inputs: {
        animated: "animated",
        backdropDismiss: "backdropDismiss",
        buttons: "buttons",
        cssClass: "cssClass",
        enterAnimation: "enterAnimation",
        header: "header",
        htmlAttributes: "htmlAttributes",
        isOpen: "isOpen",
        keyboardClose: "keyboardClose",
        leaveAnimation: "leaveAnimation",
        mode: "mode",
        subHeader: "subHeader",
        translucent: "translucent",
        trigger: "trigger"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonActionSheet_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonActionSheet = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$7,
    inputs: ['animated', 'backdropDismiss', 'buttons', 'cssClass', 'enterAnimation', 'header', 'htmlAttributes', 'isOpen', 'keyboardClose', 'leaveAnimation', 'mode', 'subHeader', 'translucent', 'trigger'],
    methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss']
  })], IonActionSheet);
  return IonActionSheet;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonAlert = /*#__PURE__*/(() => {
  let IonAlert = class IonAlert {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionAlertDidPresent', 'ionAlertWillPresent', 'ionAlertWillDismiss', 'ionAlertDidDismiss', 'didPresent', 'willPresent', 'willDismiss', 'didDismiss']);
    }
    /** @nocollapse */
    static ɵfac = function IonAlert_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonAlert)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonAlert,
      selectors: [["ion-alert"]],
      inputs: {
        animated: "animated",
        backdropDismiss: "backdropDismiss",
        buttons: "buttons",
        cssClass: "cssClass",
        enterAnimation: "enterAnimation",
        header: "header",
        htmlAttributes: "htmlAttributes",
        inputs: "inputs",
        isOpen: "isOpen",
        keyboardClose: "keyboardClose",
        leaveAnimation: "leaveAnimation",
        message: "message",
        mode: "mode",
        subHeader: "subHeader",
        translucent: "translucent",
        trigger: "trigger"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonAlert_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonAlert = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$8,
    inputs: ['animated', 'backdropDismiss', 'buttons', 'cssClass', 'enterAnimation', 'header', 'htmlAttributes', 'inputs', 'isOpen', 'keyboardClose', 'leaveAnimation', 'message', 'mode', 'subHeader', 'translucent', 'trigger'],
    methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss']
  })], IonAlert);
  return IonAlert;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonApp = /*#__PURE__*/(() => {
  let IonApp = class IonApp {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonApp_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonApp)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonApp,
      selectors: [["ion-app"]],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonApp_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonApp = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$9,
    methods: ['setFocus']
  })], IonApp);
  return IonApp;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonAvatar = /*#__PURE__*/(() => {
  let IonAvatar = class IonAvatar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonAvatar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonAvatar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonAvatar,
      selectors: [["ion-avatar"]],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonAvatar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonAvatar = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$a
  })], IonAvatar);
  return IonAvatar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonBackdrop = /*#__PURE__*/(() => {
  let IonBackdrop = class IonBackdrop {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionBackdropTap']);
    }
    /** @nocollapse */
    static ɵfac = function IonBackdrop_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonBackdrop)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonBackdrop,
      selectors: [["ion-backdrop"]],
      inputs: {
        stopPropagation: "stopPropagation",
        tappable: "tappable",
        visible: "visible"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonBackdrop_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonBackdrop = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$b,
    inputs: ['stopPropagation', 'tappable', 'visible']
  })], IonBackdrop);
  return IonBackdrop;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonBadge = /*#__PURE__*/(() => {
  let IonBadge = class IonBadge {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonBadge_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonBadge)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonBadge,
      selectors: [["ion-badge"]],
      inputs: {
        color: "color",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonBadge_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonBadge = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$c,
    inputs: ['color', 'mode']
  })], IonBadge);
  return IonBadge;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonBreadcrumb = /*#__PURE__*/(() => {
  let IonBreadcrumb = class IonBreadcrumb {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionFocus', 'ionBlur']);
    }
    /** @nocollapse */
    static ɵfac = function IonBreadcrumb_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonBreadcrumb)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonBreadcrumb,
      selectors: [["ion-breadcrumb"]],
      inputs: {
        active: "active",
        color: "color",
        disabled: "disabled",
        download: "download",
        href: "href",
        mode: "mode",
        rel: "rel",
        routerAnimation: "routerAnimation",
        routerDirection: "routerDirection",
        separator: "separator",
        target: "target"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonBreadcrumb_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonBreadcrumb = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$d,
    inputs: ['active', 'color', 'disabled', 'download', 'href', 'mode', 'rel', 'routerAnimation', 'routerDirection', 'separator', 'target']
  })], IonBreadcrumb);
  return IonBreadcrumb;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonBreadcrumbs = /*#__PURE__*/(() => {
  let IonBreadcrumbs = class IonBreadcrumbs {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionCollapsedClick']);
    }
    /** @nocollapse */
    static ɵfac = function IonBreadcrumbs_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonBreadcrumbs)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonBreadcrumbs,
      selectors: [["ion-breadcrumbs"]],
      inputs: {
        color: "color",
        itemsAfterCollapse: "itemsAfterCollapse",
        itemsBeforeCollapse: "itemsBeforeCollapse",
        maxItems: "maxItems",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonBreadcrumbs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonBreadcrumbs = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$e,
    inputs: ['color', 'itemsAfterCollapse', 'itemsBeforeCollapse', 'maxItems', 'mode']
  })], IonBreadcrumbs);
  return IonBreadcrumbs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonButton = /*#__PURE__*/(() => {
  let IonButton = class IonButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionFocus', 'ionBlur']);
    }
    /** @nocollapse */
    static ɵfac = function IonButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonButton,
      selectors: [["ion-button"]],
      inputs: {
        buttonType: "buttonType",
        color: "color",
        disabled: "disabled",
        download: "download",
        expand: "expand",
        fill: "fill",
        form: "form",
        href: "href",
        mode: "mode",
        rel: "rel",
        routerAnimation: "routerAnimation",
        routerDirection: "routerDirection",
        shape: "shape",
        size: "size",
        strong: "strong",
        target: "target",
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonButton = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$f,
    inputs: ['buttonType', 'color', 'disabled', 'download', 'expand', 'fill', 'form', 'href', 'mode', 'rel', 'routerAnimation', 'routerDirection', 'shape', 'size', 'strong', 'target', 'type']
  })], IonButton);
  return IonButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonButtons = /*#__PURE__*/(() => {
  let IonButtons = class IonButtons {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonButtons_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonButtons)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonButtons,
      selectors: [["ion-buttons"]],
      inputs: {
        collapse: "collapse"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonButtons_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonButtons = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$g,
    inputs: ['collapse']
  })], IonButtons);
  return IonButtons;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonCard = /*#__PURE__*/(() => {
  let IonCard = class IonCard {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonCard_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonCard)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonCard,
      selectors: [["ion-card"]],
      inputs: {
        button: "button",
        color: "color",
        disabled: "disabled",
        download: "download",
        href: "href",
        mode: "mode",
        rel: "rel",
        routerAnimation: "routerAnimation",
        routerDirection: "routerDirection",
        target: "target",
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonCard_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonCard = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$h,
    inputs: ['button', 'color', 'disabled', 'download', 'href', 'mode', 'rel', 'routerAnimation', 'routerDirection', 'target', 'type']
  })], IonCard);
  return IonCard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonCardContent = /*#__PURE__*/(() => {
  let IonCardContent = class IonCardContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonCardContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonCardContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonCardContent,
      selectors: [["ion-card-content"]],
      inputs: {
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonCardContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonCardContent = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$i,
    inputs: ['mode']
  })], IonCardContent);
  return IonCardContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonCardHeader = /*#__PURE__*/(() => {
  let IonCardHeader = class IonCardHeader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonCardHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonCardHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonCardHeader,
      selectors: [["ion-card-header"]],
      inputs: {
        color: "color",
        mode: "mode",
        translucent: "translucent"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonCardHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonCardHeader = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$j,
    inputs: ['color', 'mode', 'translucent']
  })], IonCardHeader);
  return IonCardHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonCardSubtitle = /*#__PURE__*/(() => {
  let IonCardSubtitle = class IonCardSubtitle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonCardSubtitle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonCardSubtitle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonCardSubtitle,
      selectors: [["ion-card-subtitle"]],
      inputs: {
        color: "color",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonCardSubtitle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonCardSubtitle = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$k,
    inputs: ['color', 'mode']
  })], IonCardSubtitle);
  return IonCardSubtitle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonCardTitle = /*#__PURE__*/(() => {
  let IonCardTitle = class IonCardTitle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonCardTitle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonCardTitle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonCardTitle,
      selectors: [["ion-card-title"]],
      inputs: {
        color: "color",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonCardTitle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonCardTitle = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$l,
    inputs: ['color', 'mode']
  })], IonCardTitle);
  return IonCardTitle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonChip = /*#__PURE__*/(() => {
  let IonChip = class IonChip {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonChip_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonChip)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonChip,
      selectors: [["ion-chip"]],
      inputs: {
        color: "color",
        disabled: "disabled",
        mode: "mode",
        outline: "outline"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonChip_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonChip = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$m,
    inputs: ['color', 'disabled', 'mode', 'outline']
  })], IonChip);
  return IonChip;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonCol = /*#__PURE__*/(() => {
  let IonCol = class IonCol {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonCol_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonCol)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonCol,
      selectors: [["ion-col"]],
      inputs: {
        offset: "offset",
        offsetLg: "offsetLg",
        offsetMd: "offsetMd",
        offsetSm: "offsetSm",
        offsetXl: "offsetXl",
        offsetXs: "offsetXs",
        pull: "pull",
        pullLg: "pullLg",
        pullMd: "pullMd",
        pullSm: "pullSm",
        pullXl: "pullXl",
        pullXs: "pullXs",
        push: "push",
        pushLg: "pushLg",
        pushMd: "pushMd",
        pushSm: "pushSm",
        pushXl: "pushXl",
        pushXs: "pushXs",
        size: "size",
        sizeLg: "sizeLg",
        sizeMd: "sizeMd",
        sizeSm: "sizeSm",
        sizeXl: "sizeXl",
        sizeXs: "sizeXs"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonCol_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonCol = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$n,
    inputs: ['offset', 'offsetLg', 'offsetMd', 'offsetSm', 'offsetXl', 'offsetXs', 'pull', 'pullLg', 'pullMd', 'pullSm', 'pullXl', 'pullXs', 'push', 'pushLg', 'pushMd', 'pushSm', 'pushXl', 'pushXs', 'size', 'sizeLg', 'sizeMd', 'sizeSm', 'sizeXl', 'sizeXs']
  })], IonCol);
  return IonCol;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonContent = /*#__PURE__*/(() => {
  let IonContent = class IonContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionScrollStart', 'ionScroll', 'ionScrollEnd']);
    }
    /** @nocollapse */
    static ɵfac = function IonContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonContent,
      selectors: [["ion-content"]],
      inputs: {
        color: "color",
        fixedSlotPlacement: "fixedSlotPlacement",
        forceOverscroll: "forceOverscroll",
        fullscreen: "fullscreen",
        scrollEvents: "scrollEvents",
        scrollX: "scrollX",
        scrollY: "scrollY"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonContent = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$o,
    inputs: ['color', 'fixedSlotPlacement', 'forceOverscroll', 'fullscreen', 'scrollEvents', 'scrollX', 'scrollY'],
    methods: ['getScrollElement', 'scrollToTop', 'scrollToBottom', 'scrollByPoint', 'scrollToPoint']
  })], IonContent);
  return IonContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonDatetimeButton = /*#__PURE__*/(() => {
  let IonDatetimeButton = class IonDatetimeButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonDatetimeButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonDatetimeButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonDatetimeButton,
      selectors: [["ion-datetime-button"]],
      inputs: {
        color: "color",
        datetime: "datetime",
        disabled: "disabled",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonDatetimeButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonDatetimeButton = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$p,
    inputs: ['color', 'datetime', 'disabled', 'mode']
  })], IonDatetimeButton);
  return IonDatetimeButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonFab = /*#__PURE__*/(() => {
  let IonFab = class IonFab {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonFab_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonFab)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonFab,
      selectors: [["ion-fab"]],
      inputs: {
        activated: "activated",
        edge: "edge",
        horizontal: "horizontal",
        vertical: "vertical"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonFab_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonFab = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$q,
    inputs: ['activated', 'edge', 'horizontal', 'vertical'],
    methods: ['close']
  })], IonFab);
  return IonFab;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonFabButton = /*#__PURE__*/(() => {
  let IonFabButton = class IonFabButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionFocus', 'ionBlur']);
    }
    /** @nocollapse */
    static ɵfac = function IonFabButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonFabButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonFabButton,
      selectors: [["ion-fab-button"]],
      inputs: {
        activated: "activated",
        closeIcon: "closeIcon",
        color: "color",
        disabled: "disabled",
        download: "download",
        href: "href",
        mode: "mode",
        rel: "rel",
        routerAnimation: "routerAnimation",
        routerDirection: "routerDirection",
        show: "show",
        size: "size",
        target: "target",
        translucent: "translucent",
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonFabButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonFabButton = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$r,
    inputs: ['activated', 'closeIcon', 'color', 'disabled', 'download', 'href', 'mode', 'rel', 'routerAnimation', 'routerDirection', 'show', 'size', 'target', 'translucent', 'type']
  })], IonFabButton);
  return IonFabButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonFabList = /*#__PURE__*/(() => {
  let IonFabList = class IonFabList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonFabList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonFabList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonFabList,
      selectors: [["ion-fab-list"]],
      inputs: {
        activated: "activated",
        side: "side"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonFabList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonFabList = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$s,
    inputs: ['activated', 'side']
  })], IonFabList);
  return IonFabList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonFooter = /*#__PURE__*/(() => {
  let IonFooter = class IonFooter {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonFooter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonFooter)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonFooter,
      selectors: [["ion-footer"]],
      inputs: {
        collapse: "collapse",
        mode: "mode",
        translucent: "translucent"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonFooter_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonFooter = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$t,
    inputs: ['collapse', 'mode', 'translucent']
  })], IonFooter);
  return IonFooter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonGrid = /*#__PURE__*/(() => {
  let IonGrid = class IonGrid {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonGrid_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonGrid)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonGrid,
      selectors: [["ion-grid"]],
      inputs: {
        fixed: "fixed"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonGrid_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonGrid = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$u,
    inputs: ['fixed']
  })], IonGrid);
  return IonGrid;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonHeader = /*#__PURE__*/(() => {
  let IonHeader = class IonHeader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonHeader,
      selectors: [["ion-header"]],
      inputs: {
        collapse: "collapse",
        mode: "mode",
        translucent: "translucent"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonHeader = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$v,
    inputs: ['collapse', 'mode', 'translucent']
  })], IonHeader);
  return IonHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonImg = /*#__PURE__*/(() => {
  let IonImg = class IonImg {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionImgWillLoad', 'ionImgDidLoad', 'ionError']);
    }
    /** @nocollapse */
    static ɵfac = function IonImg_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonImg)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonImg,
      selectors: [["ion-img"]],
      inputs: {
        alt: "alt",
        src: "src"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonImg_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonImg = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$w,
    inputs: ['alt', 'src']
  })], IonImg);
  return IonImg;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonInfiniteScroll = /*#__PURE__*/(() => {
  let IonInfiniteScroll = class IonInfiniteScroll {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionInfinite']);
    }
    /** @nocollapse */
    static ɵfac = function IonInfiniteScroll_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonInfiniteScroll)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonInfiniteScroll,
      selectors: [["ion-infinite-scroll"]],
      inputs: {
        disabled: "disabled",
        position: "position",
        threshold: "threshold"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonInfiniteScroll_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonInfiniteScroll = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$x,
    inputs: ['disabled', 'position', 'threshold'],
    methods: ['complete']
  })], IonInfiniteScroll);
  return IonInfiniteScroll;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonInfiniteScrollContent = /*#__PURE__*/(() => {
  let IonInfiniteScrollContent = class IonInfiniteScrollContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonInfiniteScrollContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonInfiniteScrollContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonInfiniteScrollContent,
      selectors: [["ion-infinite-scroll-content"]],
      inputs: {
        loadingSpinner: "loadingSpinner",
        loadingText: "loadingText"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonInfiniteScrollContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonInfiniteScrollContent = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$y,
    inputs: ['loadingSpinner', 'loadingText']
  })], IonInfiniteScrollContent);
  return IonInfiniteScrollContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonInputPasswordToggle = /*#__PURE__*/(() => {
  let IonInputPasswordToggle = class IonInputPasswordToggle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonInputPasswordToggle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonInputPasswordToggle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonInputPasswordToggle,
      selectors: [["ion-input-password-toggle"]],
      inputs: {
        color: "color",
        hideIcon: "hideIcon",
        mode: "mode",
        showIcon: "showIcon"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonInputPasswordToggle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonInputPasswordToggle = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$z,
    inputs: ['color', 'hideIcon', 'mode', 'showIcon']
  })], IonInputPasswordToggle);
  return IonInputPasswordToggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonItem = /*#__PURE__*/(() => {
  let IonItem = class IonItem {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonItem_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonItem)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonItem,
      selectors: [["ion-item"]],
      inputs: {
        button: "button",
        color: "color",
        detail: "detail",
        detailIcon: "detailIcon",
        disabled: "disabled",
        download: "download",
        href: "href",
        lines: "lines",
        mode: "mode",
        rel: "rel",
        routerAnimation: "routerAnimation",
        routerDirection: "routerDirection",
        target: "target",
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonItem_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonItem = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$A,
    inputs: ['button', 'color', 'detail', 'detailIcon', 'disabled', 'download', 'href', 'lines', 'mode', 'rel', 'routerAnimation', 'routerDirection', 'target', 'type']
  })], IonItem);
  return IonItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonItemDivider = /*#__PURE__*/(() => {
  let IonItemDivider = class IonItemDivider {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonItemDivider_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonItemDivider)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonItemDivider,
      selectors: [["ion-item-divider"]],
      inputs: {
        color: "color",
        mode: "mode",
        sticky: "sticky"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonItemDivider_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonItemDivider = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$B,
    inputs: ['color', 'mode', 'sticky']
  })], IonItemDivider);
  return IonItemDivider;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonItemGroup = /*#__PURE__*/(() => {
  let IonItemGroup = class IonItemGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonItemGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonItemGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonItemGroup,
      selectors: [["ion-item-group"]],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonItemGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonItemGroup = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$C
  })], IonItemGroup);
  return IonItemGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonItemOption = /*#__PURE__*/(() => {
  let IonItemOption = class IonItemOption {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonItemOption_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonItemOption)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonItemOption,
      selectors: [["ion-item-option"]],
      inputs: {
        color: "color",
        disabled: "disabled",
        download: "download",
        expandable: "expandable",
        href: "href",
        mode: "mode",
        rel: "rel",
        target: "target",
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonItemOption_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonItemOption = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$D,
    inputs: ['color', 'disabled', 'download', 'expandable', 'href', 'mode', 'rel', 'target', 'type']
  })], IonItemOption);
  return IonItemOption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonItemOptions = /*#__PURE__*/(() => {
  let IonItemOptions = class IonItemOptions {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionSwipe']);
    }
    /** @nocollapse */
    static ɵfac = function IonItemOptions_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonItemOptions)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonItemOptions,
      selectors: [["ion-item-options"]],
      inputs: {
        side: "side"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonItemOptions_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonItemOptions = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$E,
    inputs: ['side']
  })], IonItemOptions);
  return IonItemOptions;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonItemSliding = /*#__PURE__*/(() => {
  let IonItemSliding = class IonItemSliding {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionDrag']);
    }
    /** @nocollapse */
    static ɵfac = function IonItemSliding_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonItemSliding)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonItemSliding,
      selectors: [["ion-item-sliding"]],
      inputs: {
        disabled: "disabled"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonItemSliding_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonItemSliding = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$F,
    inputs: ['disabled'],
    methods: ['getOpenAmount', 'getSlidingRatio', 'open', 'close', 'closeOpened']
  })], IonItemSliding);
  return IonItemSliding;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonLabel = /*#__PURE__*/(() => {
  let IonLabel = class IonLabel {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonLabel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonLabel)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonLabel,
      selectors: [["ion-label"]],
      inputs: {
        color: "color",
        mode: "mode",
        position: "position"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonLabel_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonLabel = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$G,
    inputs: ['color', 'mode', 'position']
  })], IonLabel);
  return IonLabel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonList = /*#__PURE__*/(() => {
  let IonList = class IonList {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonList_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonList)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonList,
      selectors: [["ion-list"]],
      inputs: {
        inset: "inset",
        lines: "lines",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonList_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonList = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$H,
    inputs: ['inset', 'lines', 'mode'],
    methods: ['closeSlidingItems']
  })], IonList);
  return IonList;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonListHeader = /*#__PURE__*/(() => {
  let IonListHeader = class IonListHeader {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonListHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonListHeader)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonListHeader,
      selectors: [["ion-list-header"]],
      inputs: {
        color: "color",
        lines: "lines",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonListHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonListHeader = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$I,
    inputs: ['color', 'lines', 'mode']
  })], IonListHeader);
  return IonListHeader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonLoading = /*#__PURE__*/(() => {
  let IonLoading = class IonLoading {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionLoadingDidPresent', 'ionLoadingWillPresent', 'ionLoadingWillDismiss', 'ionLoadingDidDismiss', 'didPresent', 'willPresent', 'willDismiss', 'didDismiss']);
    }
    /** @nocollapse */
    static ɵfac = function IonLoading_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonLoading)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonLoading,
      selectors: [["ion-loading"]],
      inputs: {
        animated: "animated",
        backdropDismiss: "backdropDismiss",
        cssClass: "cssClass",
        duration: "duration",
        enterAnimation: "enterAnimation",
        htmlAttributes: "htmlAttributes",
        isOpen: "isOpen",
        keyboardClose: "keyboardClose",
        leaveAnimation: "leaveAnimation",
        message: "message",
        mode: "mode",
        showBackdrop: "showBackdrop",
        spinner: "spinner",
        translucent: "translucent",
        trigger: "trigger"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonLoading_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonLoading = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$J,
    inputs: ['animated', 'backdropDismiss', 'cssClass', 'duration', 'enterAnimation', 'htmlAttributes', 'isOpen', 'keyboardClose', 'leaveAnimation', 'message', 'mode', 'showBackdrop', 'spinner', 'translucent', 'trigger'],
    methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss']
  })], IonLoading);
  return IonLoading;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonMenu = /*#__PURE__*/(() => {
  let IonMenu = class IonMenu {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionWillOpen', 'ionWillClose', 'ionDidOpen', 'ionDidClose']);
    }
    /** @nocollapse */
    static ɵfac = function IonMenu_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonMenu)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonMenu,
      selectors: [["ion-menu"]],
      inputs: {
        contentId: "contentId",
        disabled: "disabled",
        maxEdgeStart: "maxEdgeStart",
        menuId: "menuId",
        side: "side",
        swipeGesture: "swipeGesture",
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonMenu_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonMenu = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$K,
    inputs: ['contentId', 'disabled', 'maxEdgeStart', 'menuId', 'side', 'swipeGesture', 'type'],
    methods: ['isOpen', 'isActive', 'open', 'close', 'toggle', 'setOpen']
  })], IonMenu);
  return IonMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonMenuButton = /*#__PURE__*/(() => {
  let IonMenuButton = class IonMenuButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonMenuButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonMenuButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonMenuButton,
      selectors: [["ion-menu-button"]],
      inputs: {
        autoHide: "autoHide",
        color: "color",
        disabled: "disabled",
        menu: "menu",
        mode: "mode",
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonMenuButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonMenuButton = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$L,
    inputs: ['autoHide', 'color', 'disabled', 'menu', 'mode', 'type']
  })], IonMenuButton);
  return IonMenuButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonMenuToggle = /*#__PURE__*/(() => {
  let IonMenuToggle = class IonMenuToggle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonMenuToggle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonMenuToggle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonMenuToggle,
      selectors: [["ion-menu-toggle"]],
      inputs: {
        autoHide: "autoHide",
        menu: "menu"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonMenuToggle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonMenuToggle = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$M,
    inputs: ['autoHide', 'menu']
  })], IonMenuToggle);
  return IonMenuToggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonNavLink = /*#__PURE__*/(() => {
  let IonNavLink = class IonNavLink {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonNavLink_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonNavLink)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonNavLink,
      selectors: [["ion-nav-link"]],
      inputs: {
        component: "component",
        componentProps: "componentProps",
        routerAnimation: "routerAnimation",
        routerDirection: "routerDirection"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonNavLink_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonNavLink = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$N,
    inputs: ['component', 'componentProps', 'routerAnimation', 'routerDirection']
  })], IonNavLink);
  return IonNavLink;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonNote = /*#__PURE__*/(() => {
  let IonNote = class IonNote {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonNote_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonNote)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonNote,
      selectors: [["ion-note"]],
      inputs: {
        color: "color",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonNote_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonNote = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$O,
    inputs: ['color', 'mode']
  })], IonNote);
  return IonNote;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonPicker = /*#__PURE__*/(() => {
  let IonPicker = class IonPicker {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonPicker_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonPicker)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonPicker,
      selectors: [["ion-picker"]],
      inputs: {
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonPicker_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonPicker = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$P,
    inputs: ['mode']
  })], IonPicker);
  return IonPicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonPickerColumn = /*#__PURE__*/(() => {
  let IonPickerColumn = class IonPickerColumn {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange']);
    }
    /** @nocollapse */
    static ɵfac = function IonPickerColumn_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonPickerColumn)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonPickerColumn,
      selectors: [["ion-picker-column"]],
      inputs: {
        color: "color",
        disabled: "disabled",
        mode: "mode",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonPickerColumn_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonPickerColumn = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$Q,
    inputs: ['color', 'disabled', 'mode', 'value'],
    methods: ['setFocus']
  })], IonPickerColumn);
  return IonPickerColumn;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonPickerColumnOption = /*#__PURE__*/(() => {
  let IonPickerColumnOption = class IonPickerColumnOption {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonPickerColumnOption_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonPickerColumnOption)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonPickerColumnOption,
      selectors: [["ion-picker-column-option"]],
      inputs: {
        color: "color",
        disabled: "disabled",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonPickerColumnOption_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonPickerColumnOption = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$R,
    inputs: ['color', 'disabled', 'value']
  })], IonPickerColumnOption);
  return IonPickerColumnOption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonPickerLegacy = /*#__PURE__*/(() => {
  let IonPickerLegacy = class IonPickerLegacy {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionPickerDidPresent', 'ionPickerWillPresent', 'ionPickerWillDismiss', 'ionPickerDidDismiss', 'didPresent', 'willPresent', 'willDismiss', 'didDismiss']);
    }
    /** @nocollapse */
    static ɵfac = function IonPickerLegacy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonPickerLegacy)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonPickerLegacy,
      selectors: [["ion-picker-legacy"]],
      inputs: {
        animated: "animated",
        backdropDismiss: "backdropDismiss",
        buttons: "buttons",
        columns: "columns",
        cssClass: "cssClass",
        duration: "duration",
        enterAnimation: "enterAnimation",
        htmlAttributes: "htmlAttributes",
        isOpen: "isOpen",
        keyboardClose: "keyboardClose",
        leaveAnimation: "leaveAnimation",
        mode: "mode",
        showBackdrop: "showBackdrop",
        trigger: "trigger"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonPickerLegacy_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonPickerLegacy = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$S,
    inputs: ['animated', 'backdropDismiss', 'buttons', 'columns', 'cssClass', 'duration', 'enterAnimation', 'htmlAttributes', 'isOpen', 'keyboardClose', 'leaveAnimation', 'mode', 'showBackdrop', 'trigger'],
    methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss', 'getColumn']
  })], IonPickerLegacy);
  return IonPickerLegacy;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonProgressBar = /*#__PURE__*/(() => {
  let IonProgressBar = class IonProgressBar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonProgressBar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonProgressBar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonProgressBar,
      selectors: [["ion-progress-bar"]],
      inputs: {
        buffer: "buffer",
        color: "color",
        mode: "mode",
        reversed: "reversed",
        type: "type",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonProgressBar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonProgressBar = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$T,
    inputs: ['buffer', 'color', 'mode', 'reversed', 'type', 'value']
  })], IonProgressBar);
  return IonProgressBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonRadio = /*#__PURE__*/(() => {
  let IonRadio = class IonRadio {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionFocus', 'ionBlur']);
    }
    /** @nocollapse */
    static ɵfac = function IonRadio_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRadio)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRadio,
      selectors: [["ion-radio"]],
      inputs: {
        alignment: "alignment",
        color: "color",
        disabled: "disabled",
        justify: "justify",
        labelPlacement: "labelPlacement",
        mode: "mode",
        name: "name",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonRadio_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonRadio = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$U,
    inputs: ['alignment', 'color', 'disabled', 'justify', 'labelPlacement', 'mode', 'name', 'value']
  })], IonRadio);
  return IonRadio;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonRefresher = /*#__PURE__*/(() => {
  let IonRefresher = class IonRefresher {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionRefresh', 'ionPull', 'ionStart']);
    }
    /** @nocollapse */
    static ɵfac = function IonRefresher_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRefresher)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRefresher,
      selectors: [["ion-refresher"]],
      inputs: {
        closeDuration: "closeDuration",
        disabled: "disabled",
        mode: "mode",
        pullFactor: "pullFactor",
        pullMax: "pullMax",
        pullMin: "pullMin",
        snapbackDuration: "snapbackDuration"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonRefresher_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonRefresher = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$V,
    inputs: ['closeDuration', 'disabled', 'mode', 'pullFactor', 'pullMax', 'pullMin', 'snapbackDuration'],
    methods: ['complete', 'cancel', 'getProgress']
  })], IonRefresher);
  return IonRefresher;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonRefresherContent = /*#__PURE__*/(() => {
  let IonRefresherContent = class IonRefresherContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonRefresherContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRefresherContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRefresherContent,
      selectors: [["ion-refresher-content"]],
      inputs: {
        pullingIcon: "pullingIcon",
        pullingText: "pullingText",
        refreshingSpinner: "refreshingSpinner",
        refreshingText: "refreshingText"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonRefresherContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonRefresherContent = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$W,
    inputs: ['pullingIcon', 'pullingText', 'refreshingSpinner', 'refreshingText']
  })], IonRefresherContent);
  return IonRefresherContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonReorder = /*#__PURE__*/(() => {
  let IonReorder = class IonReorder {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonReorder_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonReorder)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonReorder,
      selectors: [["ion-reorder"]],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonReorder_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonReorder = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$X
  })], IonReorder);
  return IonReorder;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonReorderGroup = /*#__PURE__*/(() => {
  let IonReorderGroup = class IonReorderGroup {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionItemReorder', 'ionReorderStart', 'ionReorderMove', 'ionReorderEnd']);
    }
    /** @nocollapse */
    static ɵfac = function IonReorderGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonReorderGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonReorderGroup,
      selectors: [["ion-reorder-group"]],
      inputs: {
        disabled: "disabled"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonReorderGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonReorderGroup = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$Y,
    inputs: ['disabled'],
    methods: ['complete']
  })], IonReorderGroup);
  return IonReorderGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonRippleEffect = /*#__PURE__*/(() => {
  let IonRippleEffect = class IonRippleEffect {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonRippleEffect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRippleEffect)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRippleEffect,
      selectors: [["ion-ripple-effect"]],
      inputs: {
        type: "type"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonRippleEffect_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonRippleEffect = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$Z,
    inputs: ['type'],
    methods: ['addRipple']
  })], IonRippleEffect);
  return IonRippleEffect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonRow = /*#__PURE__*/(() => {
  let IonRow = class IonRow {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonRow_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRow)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRow,
      selectors: [["ion-row"]],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonRow_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonRow = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$_
  })], IonRow);
  return IonRow;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSegmentButton = /*#__PURE__*/(() => {
  let IonSegmentButton = class IonSegmentButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonSegmentButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSegmentButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSegmentButton,
      selectors: [["ion-segment-button"]],
      inputs: {
        contentId: "contentId",
        disabled: "disabled",
        layout: "layout",
        mode: "mode",
        type: "type",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSegmentButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSegmentButton = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$$,
    inputs: ['contentId', 'disabled', 'layout', 'mode', 'type', 'value']
  })], IonSegmentButton);
  return IonSegmentButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSegmentContent = /*#__PURE__*/(() => {
  let IonSegmentContent = class IonSegmentContent {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonSegmentContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSegmentContent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSegmentContent,
      selectors: [["ion-segment-content"]],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSegmentContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSegmentContent = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$10
  })], IonSegmentContent);
  return IonSegmentContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSegmentView = /*#__PURE__*/(() => {
  let IonSegmentView = class IonSegmentView {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionSegmentViewScroll']);
    }
    /** @nocollapse */
    static ɵfac = function IonSegmentView_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSegmentView)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSegmentView,
      selectors: [["ion-segment-view"]],
      inputs: {
        disabled: "disabled"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSegmentView_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSegmentView = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$11,
    inputs: ['disabled']
  })], IonSegmentView);
  return IonSegmentView;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSelectModal = /*#__PURE__*/(() => {
  let IonSelectModal = class IonSelectModal {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonSelectModal_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSelectModal)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSelectModal,
      selectors: [["ion-select-modal"]],
      inputs: {
        header: "header",
        multiple: "multiple",
        options: "options"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSelectModal_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSelectModal = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$12,
    inputs: ['header', 'multiple', 'options']
  })], IonSelectModal);
  return IonSelectModal;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSelectOption = /*#__PURE__*/(() => {
  let IonSelectOption = class IonSelectOption {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonSelectOption_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSelectOption)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSelectOption,
      selectors: [["ion-select-option"]],
      inputs: {
        disabled: "disabled",
        value: "value"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSelectOption_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSelectOption = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$13,
    inputs: ['disabled', 'value']
  })], IonSelectOption);
  return IonSelectOption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSkeletonText = /*#__PURE__*/(() => {
  let IonSkeletonText = class IonSkeletonText {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonSkeletonText_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSkeletonText)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSkeletonText,
      selectors: [["ion-skeleton-text"]],
      inputs: {
        animated: "animated"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSkeletonText_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSkeletonText = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$14,
    inputs: ['animated']
  })], IonSkeletonText);
  return IonSkeletonText;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSpinner = /*#__PURE__*/(() => {
  let IonSpinner = class IonSpinner {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonSpinner_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSpinner)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSpinner,
      selectors: [["ion-spinner"]],
      inputs: {
        color: "color",
        duration: "duration",
        name: "name",
        paused: "paused"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSpinner_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSpinner = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$15,
    inputs: ['color', 'duration', 'name', 'paused']
  })], IonSpinner);
  return IonSpinner;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonSplitPane = /*#__PURE__*/(() => {
  let IonSplitPane = class IonSplitPane {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionSplitPaneVisible']);
    }
    /** @nocollapse */
    static ɵfac = function IonSplitPane_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSplitPane)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSplitPane,
      selectors: [["ion-split-pane"]],
      inputs: {
        contentId: "contentId",
        disabled: "disabled",
        when: "when"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSplitPane_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSplitPane = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$16,
    inputs: ['contentId', 'disabled', 'when']
  })], IonSplitPane);
  return IonSplitPane;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonTab = /*#__PURE__*/(() => {
  let IonTab = class IonTab {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonTab_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonTab)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonTab,
      selectors: [["ion-tab"]],
      inputs: {
        component: "component",
        tab: "tab"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonTab_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonTab = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$17,
    inputs: ['component', 'tab'],
    methods: ['setActive']
  })], IonTab);
  return IonTab;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonTabBar = /*#__PURE__*/(() => {
  let IonTabBar = class IonTabBar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonTabBar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonTabBar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonTabBar,
      selectors: [["ion-tab-bar"]],
      inputs: {
        color: "color",
        mode: "mode",
        selectedTab: "selectedTab",
        translucent: "translucent"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonTabBar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonTabBar = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$18,
    inputs: ['color', 'mode', 'selectedTab', 'translucent']
  })], IonTabBar);
  return IonTabBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonTabButton = /*#__PURE__*/(() => {
  let IonTabButton = class IonTabButton {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonTabButton_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonTabButton)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonTabButton,
      selectors: [["ion-tab-button"]],
      inputs: {
        disabled: "disabled",
        download: "download",
        href: "href",
        layout: "layout",
        mode: "mode",
        rel: "rel",
        selected: "selected",
        tab: "tab",
        target: "target"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonTabButton_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonTabButton = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$19,
    inputs: ['disabled', 'download', 'href', 'layout', 'mode', 'rel', 'selected', 'tab', 'target']
  })], IonTabButton);
  return IonTabButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonText = /*#__PURE__*/(() => {
  let IonText = class IonText {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonText_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonText)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonText,
      selectors: [["ion-text"]],
      inputs: {
        color: "color",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonText_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonText = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1a,
    inputs: ['color', 'mode']
  })], IonText);
  return IonText;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonThumbnail = /*#__PURE__*/(() => {
  let IonThumbnail = class IonThumbnail {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonThumbnail_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonThumbnail)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonThumbnail,
      selectors: [["ion-thumbnail"]],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonThumbnail_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonThumbnail = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1b
  })], IonThumbnail);
  return IonThumbnail;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonTitle = /*#__PURE__*/(() => {
  let IonTitle = class IonTitle {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonTitle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonTitle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonTitle,
      selectors: [["ion-title"]],
      inputs: {
        color: "color",
        size: "size"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonTitle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonTitle = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1c,
    inputs: ['color', 'size']
  })], IonTitle);
  return IonTitle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonToast = /*#__PURE__*/(() => {
  let IonToast = class IonToast {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionToastDidPresent', 'ionToastWillPresent', 'ionToastWillDismiss', 'ionToastDidDismiss', 'didPresent', 'willPresent', 'willDismiss', 'didDismiss']);
    }
    /** @nocollapse */
    static ɵfac = function IonToast_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonToast)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonToast,
      selectors: [["ion-toast"]],
      inputs: {
        animated: "animated",
        buttons: "buttons",
        color: "color",
        cssClass: "cssClass",
        duration: "duration",
        enterAnimation: "enterAnimation",
        header: "header",
        htmlAttributes: "htmlAttributes",
        icon: "icon",
        isOpen: "isOpen",
        keyboardClose: "keyboardClose",
        layout: "layout",
        leaveAnimation: "leaveAnimation",
        message: "message",
        mode: "mode",
        position: "position",
        positionAnchor: "positionAnchor",
        swipeGesture: "swipeGesture",
        translucent: "translucent",
        trigger: "trigger"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonToast_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonToast = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1d,
    inputs: ['animated', 'buttons', 'color', 'cssClass', 'duration', 'enterAnimation', 'header', 'htmlAttributes', 'icon', 'isOpen', 'keyboardClose', 'layout', 'leaveAnimation', 'message', 'mode', 'position', 'positionAnchor', 'swipeGesture', 'translucent', 'trigger'],
    methods: ['present', 'dismiss', 'onDidDismiss', 'onWillDismiss']
  })], IonToast);
  return IonToast;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonToolbar = /*#__PURE__*/(() => {
  let IonToolbar = class IonToolbar {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonToolbar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonToolbar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonToolbar,
      selectors: [["ion-toolbar"]],
      inputs: {
        color: "color",
        mode: "mode"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonToolbar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonToolbar = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1e,
    inputs: ['color', 'mode']
  })], IonToolbar);
  return IonToolbar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// eslint-disable-next-line @angular-eslint/component-class-suffix
let IonTabs = /*#__PURE__*/(() => {
  class IonTabs extends IonTabs$1 {
    outlet;
    tabBar;
    tabBars;
    tabs;
    /** @nocollapse */
    static ɵfac = /* @__PURE__ */(() => {
      let ɵIonTabs_BaseFactory;
      return function IonTabs_Factory(__ngFactoryType__) {
        return (ɵIonTabs_BaseFactory || (ɵIonTabs_BaseFactory = i0.ɵɵgetInheritedFactory(IonTabs)))(__ngFactoryType__ || IonTabs);
      };
    })();
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonTabs,
      selectors: [["ion-tabs"]],
      contentQueries: function IonTabs_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, IonTabBar, 5);
          i0.ɵɵcontentQuery(dirIndex, IonTabBar, 4);
          i0.ɵɵcontentQuery(dirIndex, IonTab, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabBar = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabBars = _t);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabs = _t);
        }
      },
      viewQuery: function IonTabs_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5, IonRouterOutlet);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.outlet = _t.first);
        }
      },
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c4,
      decls: 6,
      vars: 2,
      consts: [["tabsInner", ""], ["outlet", ""], [1, "tabs-inner"], ["tabs", "true", 3, "stackWillChange", "stackDidChange", 4, "ngIf"], [4, "ngIf"], ["tabs", "true", 3, "stackWillChange", "stackDidChange"]],
      template: function IonTabs_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵprojection(0);
          i0.ɵɵelementStart(1, "div", 2, 0);
          i0.ɵɵtemplate(3, IonTabs_ion_router_outlet_3_Template, 2, 0, "ion-router-outlet", 3)(4, IonTabs_ng_content_4_Template, 1, 0, "ng-content", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(5, 1);
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.tabs.length === 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.tabs.length > 0);
        }
      },
      dependencies: [IonRouterOutlet, NgIf],
      styles: ["[_nghost-%COMP%]{display:flex;position:absolute;inset:0;flex-direction:column;width:100%;height:100%;contain:layout size style}.tabs-inner[_ngcontent-%COMP%]{position:relative;flex:1;contain:layout size style}"]
    });
  }
  return IonTabs;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalController = /*#__PURE__*/(() => {
  class ModalController extends OverlayBaseController {
    angularDelegate = inject(AngularDelegate);
    injector = inject(Injector);
    environmentInjector = inject(EnvironmentInjector);
    constructor() {
      super(modalController);
      defineCustomElement$3();
    }
    create(opts) {
      return super.create({
        ...opts,
        delegate: this.angularDelegate.create(this.environmentInjector, this.injector, 'modal')
      });
    }
    /** @nocollapse */
    static ɵfac = function ModalController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ModalController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ModalController,
      factory: ModalController.ɵfac
    });
  }
  return ModalController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PopoverController extends OverlayBaseController {
  angularDelegate = inject(AngularDelegate);
  injector = inject(Injector);
  environmentInjector = inject(EnvironmentInjector);
  constructor() {
    super(popoverController);
    defineCustomElement$4();
  }
  create(opts) {
    return super.create({
      ...opts,
      delegate: this.angularDelegate.create(this.environmentInjector, this.injector, 'popover')
    });
  }
}
const provideIonicAngular = (config = {}) => {
  return makeEnvironmentProviders([{
    provide: ConfigToken,
    useValue: config
  }, {
    provide: APP_INITIALIZER,
    useFactory: initializeIonicAngular,
    multi: true,
    deps: [ConfigToken, DOCUMENT]
  }, provideComponentInputBinding(), AngularDelegate, ModalController, PopoverController]);
};
const initializeIonicAngular = (config, doc) => {
  return () => {
    /**
     * By default Ionic Framework hides elements that
     * are not hydrated, but in the CE build there is no
     * hydration.
     * TODO FW-2797: Remove when all integrations have been
     * migrated to CE build.
     */
    doc.documentElement.classList.add('ion-ce');
    initialize(config);
  };
};
let ActionSheetController = /*#__PURE__*/(() => {
  class ActionSheetController extends OverlayBaseController {
    constructor() {
      super(actionSheetController);
      defineCustomElement$7();
    }
    /** @nocollapse */
    static ɵfac = function ActionSheetController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ActionSheetController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ActionSheetController,
      factory: ActionSheetController.ɵfac,
      providedIn: 'root'
    });
  }
  return ActionSheetController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertController = /*#__PURE__*/(() => {
  class AlertController extends OverlayBaseController {
    constructor() {
      super(alertController);
      defineCustomElement$8();
    }
    /** @nocollapse */
    static ɵfac = function AlertController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AlertController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AlertController,
      factory: AlertController.ɵfac,
      providedIn: 'root'
    });
  }
  return AlertController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AnimationController = /*#__PURE__*/(() => {
  class AnimationController {
    /**
     * Create a new animation
     */
    create(animationId) {
      return createAnimation(animationId);
    }
    /**
     * EXPERIMENTAL
     *
     * Given a progression and a cubic bezier function,
     * this utility returns the time value(s) at which the
     * cubic bezier reaches the given time progression.
     *
     * If the cubic bezier never reaches the progression
     * the result will be an empty array.
     *
     * This is most useful for switching between easing curves
     * when doing a gesture animation (i.e. going from linear easing
     * during a drag, to another easing when `progressEnd` is called)
     */
    easingTime(p0, p1, p2, p3, progression) {
      return getTimeGivenProgression(p0, p1, p2, p3, progression);
    }
    /** @nocollapse */
    static ɵfac = function AnimationController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || AnimationController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AnimationController,
      factory: AnimationController.ɵfac,
      providedIn: 'root'
    });
  }
  return AnimationController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GestureController = /*#__PURE__*/(() => {
  class GestureController {
    zone;
    constructor(zone) {
      this.zone = zone;
    }
    /**
     * Create a new gesture
     */
    create(opts, runInsideAngularZone = false) {
      if (runInsideAngularZone) {
        Object.getOwnPropertyNames(opts).forEach(key => {
          if (typeof opts[key] === 'function') {
            const fn = opts[key];
            opts[key] = (...props) => this.zone.run(() => fn(...props));
          }
        });
      }
      return createGesture(opts);
    }
    /** @nocollapse */
    static ɵfac = function GestureController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GestureController)(i0.ɵɵinject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GestureController,
      factory: GestureController.ɵfac,
      providedIn: 'root'
    });
  }
  return GestureController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoadingController = /*#__PURE__*/(() => {
  class LoadingController extends OverlayBaseController {
    constructor() {
      super(loadingController);
      defineCustomElement$J();
    }
    /** @nocollapse */
    static ɵfac = function LoadingController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || LoadingController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: LoadingController,
      factory: LoadingController.ɵfac,
      providedIn: 'root'
    });
  }
  return LoadingController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MenuController = /*#__PURE__*/(() => {
  class MenuController extends MenuController$1 {
    constructor() {
      super(menuController);
    }
    /** @nocollapse */
    static ɵfac = function MenuController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MenuController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MenuController,
      factory: MenuController.ɵfac,
      providedIn: 'root'
    });
  }
  return MenuController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @deprecated Use the inline ion-picker component instead.
 */
let PickerController = /*#__PURE__*/(() => {
  class PickerController extends OverlayBaseController {
    constructor() {
      super(pickerController);
      defineCustomElement$S();
    }
    /** @nocollapse */
    static ɵfac = function PickerController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || PickerController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: PickerController,
      factory: PickerController.ɵfac,
      providedIn: 'root'
    });
  }
  return PickerController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ToastController = /*#__PURE__*/(() => {
  class ToastController extends OverlayBaseController {
    constructor() {
      super(toastController);
      defineCustomElement$1d();
    }
    /** @nocollapse */
    static ɵfac = function ToastController_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ToastController)();
    };
    /** @nocollapse */
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ToastController,
      factory: ToastController.ɵfac,
      providedIn: 'root'
    });
  }
  return ToastController;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonNav = /*#__PURE__*/(() => {
  let IonNav = class IonNav extends IonNav$1 {
    constructor(ref, environmentInjector, injector, angularDelegate, z, c) {
      super(ref, environmentInjector, injector, angularDelegate, z, c);
    }
    /** @nocollapse */
    static ɵfac = function IonNav_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonNav)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.EnvironmentInjector), i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i2$1.AngularDelegate), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonNav,
      selectors: [["ion-nav"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonNav_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2
    });
  };
  IonNav = __decorate([ProxyCmp$1({
    defineCustomElementFn: defineCustomElement$1f
  })], IonNav);
  return IonNav;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CHECKBOX_INPUTS = ['checked', 'color', 'disabled', 'errorText', 'helperText', 'indeterminate', 'justify', 'labelPlacement', 'mode', 'name', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$a = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonCheckbox),
  multi: true
};
let IonCheckbox = /*#__PURE__*/(() => {
  let IonCheckbox = class IonCheckbox extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange', 'ionFocus', 'ionBlur']);
    }
    writeValue(value) {
      this.elementRef.nativeElement.checked = this.lastValue = value;
      setIonicClasses(this.elementRef);
    }
    handleIonChange(el) {
      this.handleValueChange(el, el.checked);
    }
    /** @nocollapse */
    static ɵfac = function IonCheckbox_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonCheckbox)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonCheckbox,
      selectors: [["ion-checkbox"]],
      hostBindings: function IonCheckbox_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionChange", function IonCheckbox_ionChange_HostBindingHandler($event) {
            return ctx.handleIonChange($event.target);
          });
        }
      },
      inputs: {
        checked: "checked",
        color: "color",
        disabled: "disabled",
        errorText: "errorText",
        helperText: "helperText",
        indeterminate: "indeterminate",
        justify: "justify",
        labelPlacement: "labelPlacement",
        mode: "mode",
        name: "name",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$a]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonCheckbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonCheckbox = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1g,
    inputs: CHECKBOX_INPUTS
  })], IonCheckbox);
  return IonCheckbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DATETIME_INPUTS = ['cancelText', 'clearText', 'color', 'dayValues', 'disabled', 'doneText', 'firstDayOfWeek', 'formatOptions', 'highlightedDates', 'hourCycle', 'hourValues', 'isDateEnabled', 'locale', 'max', 'min', 'minuteValues', 'mode', 'monthValues', 'multiple', 'name', 'preferWheel', 'presentation', 'readonly', 'showAdjacentDays', 'showClearButton', 'showDefaultButtons', 'showDefaultTimeLabel', 'showDefaultTitle', 'size', 'titleSelectedDatesFormatter', 'value', 'yearValues'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.

 */
const accessorProvider$9 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonDatetime),
  multi: true
};
let IonDatetime = /*#__PURE__*/(() => {
  let IonDatetime = class IonDatetime extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionCancel', 'ionChange', 'ionFocus', 'ionBlur']);
    }
    handleIonChange(el) {
      this.handleValueChange(el, el.value);
    }
    /** @nocollapse */
    static ɵfac = function IonDatetime_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonDatetime)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonDatetime,
      selectors: [["ion-datetime"]],
      hostBindings: function IonDatetime_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionChange", function IonDatetime_ionChange_HostBindingHandler($event) {
            return ctx.handleIonChange($event.target);
          });
        }
      },
      inputs: {
        cancelText: "cancelText",
        clearText: "clearText",
        color: "color",
        dayValues: "dayValues",
        disabled: "disabled",
        doneText: "doneText",
        firstDayOfWeek: "firstDayOfWeek",
        formatOptions: "formatOptions",
        highlightedDates: "highlightedDates",
        hourCycle: "hourCycle",
        hourValues: "hourValues",
        isDateEnabled: "isDateEnabled",
        locale: "locale",
        max: "max",
        min: "min",
        minuteValues: "minuteValues",
        mode: "mode",
        monthValues: "monthValues",
        multiple: "multiple",
        name: "name",
        preferWheel: "preferWheel",
        presentation: "presentation",
        readonly: "readonly",
        showAdjacentDays: "showAdjacentDays",
        showClearButton: "showClearButton",
        showDefaultButtons: "showDefaultButtons",
        showDefaultTimeLabel: "showDefaultTimeLabel",
        showDefaultTitle: "showDefaultTitle",
        size: "size",
        titleSelectedDatesFormatter: "titleSelectedDatesFormatter",
        value: "value",
        yearValues: "yearValues"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$9]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonDatetime_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonDatetime = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1h,
    inputs: DATETIME_INPUTS,
    methods: ['confirm', 'reset', 'cancel']
  })], IonDatetime);
  return IonDatetime;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IonIcon = /*#__PURE__*/(() => {
  let IonIcon = class IonIcon {
    z;
    el;
    constructor(c, r, z) {
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
    }
    /** @nocollapse */
    static ɵfac = function IonIcon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonIcon)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonIcon,
      selectors: [["ion-icon"]],
      inputs: {
        color: "color",
        flipRtl: "flipRtl",
        icon: "icon",
        ios: "ios",
        lazy: "lazy",
        md: "md",
        mode: "mode",
        name: "name",
        sanitize: "sanitize",
        size: "size",
        src: "src"
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonIcon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonIcon = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1i,
    inputs: ['color', 'flipRtl', 'icon', 'ios', 'lazy', 'md', 'mode', 'name', 'sanitize', 'size', 'src']
  })], IonIcon);
  return IonIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const INPUT_INPUTS = ['accept', 'autocapitalize', 'autocomplete', 'autocorrect', 'autofocus', 'clearInput', 'clearOnEdit', 'color', 'counter', 'counterFormatter', 'debounce', 'disabled', 'enterkeyhint', 'errorText', 'fill', 'helperText', 'inputmode', 'label', 'labelPlacement', 'max', 'maxlength', 'min', 'minlength', 'mode', 'multiple', 'name', 'pattern', 'placeholder', 'readonly', 'required', 'shape', 'size', 'spellcheck', 'step', 'type', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$8 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonInput),
  multi: true
};
let IonInput = /*#__PURE__*/(() => {
  let IonInput = class IonInput extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionInput', 'ionChange', 'ionBlur', 'ionFocus']);
    }
    handleIonInput(el) {
      this.handleValueChange(el, el.value);
    }
    registerOnChange(fn) {
      super.registerOnChange(value => {
        if (this.type === 'number') {
          /**
           * If the input type is `number`, we need to convert the value to a number
           * when the value is not empty. If the value is empty, we want to treat
           * the value as null.
           */
          fn(value === '' ? null : parseFloat(value));
        } else {
          fn(value);
        }
      });
    }
    /** @nocollapse */
    static ɵfac = function IonInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonInput)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonInput,
      selectors: [["ion-input"]],
      hostBindings: function IonInput_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionInput", function IonInput_ionInput_HostBindingHandler($event) {
            return ctx.handleIonInput($event.target);
          });
        }
      },
      inputs: {
        accept: "accept",
        autocapitalize: "autocapitalize",
        autocomplete: "autocomplete",
        autocorrect: "autocorrect",
        autofocus: "autofocus",
        clearInput: "clearInput",
        clearOnEdit: "clearOnEdit",
        color: "color",
        counter: "counter",
        counterFormatter: "counterFormatter",
        debounce: "debounce",
        disabled: "disabled",
        enterkeyhint: "enterkeyhint",
        errorText: "errorText",
        fill: "fill",
        helperText: "helperText",
        inputmode: "inputmode",
        label: "label",
        labelPlacement: "labelPlacement",
        max: "max",
        maxlength: "maxlength",
        min: "min",
        minlength: "minlength",
        mode: "mode",
        multiple: "multiple",
        name: "name",
        pattern: "pattern",
        placeholder: "placeholder",
        readonly: "readonly",
        required: "required",
        shape: "shape",
        size: "size",
        spellcheck: "spellcheck",
        step: "step",
        type: "type",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$8]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonInput_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonInput = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1j,
    inputs: INPUT_INPUTS,
    methods: ['setFocus', 'getInputElement']
  })], IonInput);
  return IonInput;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const INPUT_OTP_INPUTS = ['autocapitalize', 'color', 'disabled', 'fill', 'inputmode', 'length', 'pattern', 'readonly', 'separators', 'shape', 'size', 'type', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$7 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonInputOtp),
  multi: true
};
let IonInputOtp = /*#__PURE__*/(() => {
  let IonInputOtp = class IonInputOtp extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionInput', 'ionChange', 'ionComplete', 'ionBlur', 'ionFocus']);
    }
    handleIonInput(el) {
      this.handleValueChange(el, el.value);
    }
    registerOnChange(fn) {
      super.registerOnChange(value => {
        if (this.type === 'number') {
          /**
           * If the input type is `number`, we need to convert the value to a number
           * when the value is not empty. If the value is empty, we want to treat
           * the value as null.
           */
          fn(value === '' ? null : parseFloat(value));
        } else {
          fn(value);
        }
      });
    }
    /** @nocollapse */
    static ɵfac = function IonInputOtp_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonInputOtp)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonInputOtp,
      selectors: [["ion-input-otp"]],
      hostBindings: function IonInputOtp_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionInput", function IonInputOtp_ionInput_HostBindingHandler($event) {
            return ctx.handleIonInput($event.target);
          });
        }
      },
      inputs: {
        autocapitalize: "autocapitalize",
        color: "color",
        disabled: "disabled",
        fill: "fill",
        inputmode: "inputmode",
        length: "length",
        pattern: "pattern",
        readonly: "readonly",
        separators: "separators",
        shape: "shape",
        size: "size",
        type: "type",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$7]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonInputOtp_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonInputOtp = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1k,
    inputs: INPUT_OTP_INPUTS,
    methods: ['setFocus']
  })], IonInputOtp);
  return IonInputOtp;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const RADIO_GROUP_INPUTS = ['allowEmptySelection', 'compareWith', 'errorText', 'helperText', 'name', 'value'];
/**
 * Pulling the provider into an object and using PURE  works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$6 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonRadioGroup),
  multi: true
};
let IonRadioGroup = /*#__PURE__*/(() => {
  let IonRadioGroup = class IonRadioGroup extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange']);
    }
    handleIonChange(el) {
      this.handleValueChange(el, el.value);
    }
    /** @nocollapse */
    static ɵfac = function IonRadioGroup_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRadioGroup)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRadioGroup,
      selectors: [["ion-radio-group"]],
      hostBindings: function IonRadioGroup_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionChange", function IonRadioGroup_ionChange_HostBindingHandler($event) {
            return ctx.handleIonChange($event.target);
          });
        }
      },
      inputs: {
        allowEmptySelection: "allowEmptySelection",
        compareWith: "compareWith",
        errorText: "errorText",
        helperText: "helperText",
        name: "name",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$6]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonRadioGroup_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonRadioGroup = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1l,
    inputs: RADIO_GROUP_INPUTS
  })], IonRadioGroup);
  return IonRadioGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const RANGE_INPUTS = ['activeBarStart', 'color', 'debounce', 'disabled', 'dualKnobs', 'label', 'labelPlacement', 'max', 'min', 'mode', 'name', 'pin', 'pinFormatter', 'snaps', 'step', 'ticks', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$5 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonRange),
  multi: true
};
let IonRange = /*#__PURE__*/(() => {
  let IonRange = class IonRange extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange', 'ionInput', 'ionFocus', 'ionBlur', 'ionKnobMoveStart', 'ionKnobMoveEnd']);
    }
    handleIonInput(el) {
      this.handleValueChange(el, el.value);
    }
    /** @nocollapse */
    static ɵfac = function IonRange_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonRange)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonRange,
      selectors: [["ion-range"]],
      hostBindings: function IonRange_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionInput", function IonRange_ionInput_HostBindingHandler($event) {
            return ctx.handleIonInput($event.target);
          });
        }
      },
      inputs: {
        activeBarStart: "activeBarStart",
        color: "color",
        debounce: "debounce",
        disabled: "disabled",
        dualKnobs: "dualKnobs",
        label: "label",
        labelPlacement: "labelPlacement",
        max: "max",
        min: "min",
        mode: "mode",
        name: "name",
        pin: "pin",
        pinFormatter: "pinFormatter",
        snaps: "snaps",
        step: "step",
        ticks: "ticks",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$5]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonRange_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonRange = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1m,
    inputs: RANGE_INPUTS
  })], IonRange);
  return IonRange;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SEARCHBAR_INPUTS = ['animated', 'autocomplete', 'autocorrect', 'cancelButtonIcon', 'cancelButtonText', 'clearIcon', 'color', 'debounce', 'disabled', 'enterkeyhint', 'inputmode', 'mode', 'name', 'placeholder', 'searchIcon', 'showCancelButton', 'showClearButton', 'spellcheck', 'type', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$4 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonSearchbar),
  multi: true
};
let IonSearchbar = /*#__PURE__*/(() => {
  let IonSearchbar = class IonSearchbar extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionInput', 'ionChange', 'ionCancel', 'ionClear', 'ionBlur', 'ionFocus']);
    }
    handleIonInput(el) {
      this.handleValueChange(el, el.value);
    }
    /** @nocollapse */
    static ɵfac = function IonSearchbar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSearchbar)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSearchbar,
      selectors: [["ion-searchbar"]],
      hostBindings: function IonSearchbar_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionInput", function IonSearchbar_ionInput_HostBindingHandler($event) {
            return ctx.handleIonInput($event.target);
          });
        }
      },
      inputs: {
        animated: "animated",
        autocomplete: "autocomplete",
        autocorrect: "autocorrect",
        cancelButtonIcon: "cancelButtonIcon",
        cancelButtonText: "cancelButtonText",
        clearIcon: "clearIcon",
        color: "color",
        debounce: "debounce",
        disabled: "disabled",
        enterkeyhint: "enterkeyhint",
        inputmode: "inputmode",
        mode: "mode",
        name: "name",
        placeholder: "placeholder",
        searchIcon: "searchIcon",
        showCancelButton: "showCancelButton",
        showClearButton: "showClearButton",
        spellcheck: "spellcheck",
        type: "type",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$4]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSearchbar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSearchbar = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1n,
    inputs: SEARCHBAR_INPUTS,
    methods: ['setFocus', 'getInputElement']
  })], IonSearchbar);
  return IonSearchbar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SEGMENT_INPUTS = ['color', 'disabled', 'mode', 'scrollable', 'selectOnFocus', 'swipeGesture', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$3 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonSegment),
  multi: true
};
let IonSegment = /*#__PURE__*/(() => {
  let IonSegment = class IonSegment extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange']);
    }
    handleIonChange(el) {
      this.handleValueChange(el, el.value);
    }
    /** @nocollapse */
    static ɵfac = function IonSegment_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSegment)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSegment,
      selectors: [["ion-segment"]],
      hostBindings: function IonSegment_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionChange", function IonSegment_ionChange_HostBindingHandler($event) {
            return ctx.handleIonChange($event.target);
          });
        }
      },
      inputs: {
        color: "color",
        disabled: "disabled",
        mode: "mode",
        scrollable: "scrollable",
        selectOnFocus: "selectOnFocus",
        swipeGesture: "swipeGesture",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$3]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSegment_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSegment = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1o,
    inputs: SEGMENT_INPUTS
  })], IonSegment);
  return IonSegment;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SELECT_INPUTS = ['cancelText', 'color', 'compareWith', 'disabled', 'errorText', 'expandedIcon', 'fill', 'helperText', 'interface', 'interfaceOptions', 'justify', 'label', 'labelPlacement', 'mode', 'multiple', 'name', 'okText', 'placeholder', 'selectedText', 'shape', 'toggleIcon', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$2 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonSelect),
  multi: true
};
let IonSelect = /*#__PURE__*/(() => {
  let IonSelect = class IonSelect extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange', 'ionCancel', 'ionDismiss', 'ionFocus', 'ionBlur']);
    }
    handleIonChange(el) {
      this.handleValueChange(el, el.value);
    }
    /** @nocollapse */
    static ɵfac = function IonSelect_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonSelect)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonSelect,
      selectors: [["ion-select"]],
      hostBindings: function IonSelect_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionChange", function IonSelect_ionChange_HostBindingHandler($event) {
            return ctx.handleIonChange($event.target);
          });
        }
      },
      inputs: {
        cancelText: "cancelText",
        color: "color",
        compareWith: "compareWith",
        disabled: "disabled",
        errorText: "errorText",
        expandedIcon: "expandedIcon",
        fill: "fill",
        helperText: "helperText",
        interface: "interface",
        interfaceOptions: "interfaceOptions",
        justify: "justify",
        label: "label",
        labelPlacement: "labelPlacement",
        mode: "mode",
        multiple: "multiple",
        name: "name",
        okText: "okText",
        placeholder: "placeholder",
        selectedText: "selectedText",
        shape: "shape",
        toggleIcon: "toggleIcon",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$2]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonSelect_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonSelect = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1p,
    inputs: SELECT_INPUTS,
    methods: ['open']
  })], IonSelect);
  return IonSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TEXTAREA_INPUTS = ['autoGrow', 'autocapitalize', 'autofocus', 'clearOnEdit', 'color', 'cols', 'counter', 'counterFormatter', 'debounce', 'disabled', 'enterkeyhint', 'errorText', 'fill', 'helperText', 'inputmode', 'label', 'labelPlacement', 'maxlength', 'minlength', 'mode', 'name', 'placeholder', 'readonly', 'required', 'rows', 'shape', 'spellcheck', 'value', 'wrap'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider$1 = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonTextarea),
  multi: true
};
let IonTextarea = /*#__PURE__*/(() => {
  let IonTextarea = class IonTextarea extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange', 'ionInput', 'ionBlur', 'ionFocus']);
    }
    handleIonInput(el) {
      this.handleValueChange(el, el.value);
    }
    /** @nocollapse */
    static ɵfac = function IonTextarea_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonTextarea)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonTextarea,
      selectors: [["ion-textarea"]],
      hostBindings: function IonTextarea_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionInput", function IonTextarea_ionInput_HostBindingHandler($event) {
            return ctx.handleIonInput($event.target);
          });
        }
      },
      inputs: {
        autoGrow: "autoGrow",
        autocapitalize: "autocapitalize",
        autofocus: "autofocus",
        clearOnEdit: "clearOnEdit",
        color: "color",
        cols: "cols",
        counter: "counter",
        counterFormatter: "counterFormatter",
        debounce: "debounce",
        disabled: "disabled",
        enterkeyhint: "enterkeyhint",
        errorText: "errorText",
        fill: "fill",
        helperText: "helperText",
        inputmode: "inputmode",
        label: "label",
        labelPlacement: "labelPlacement",
        maxlength: "maxlength",
        minlength: "minlength",
        mode: "mode",
        name: "name",
        placeholder: "placeholder",
        readonly: "readonly",
        required: "required",
        rows: "rows",
        shape: "shape",
        spellcheck: "spellcheck",
        value: "value",
        wrap: "wrap"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider$1]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonTextarea_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonTextarea = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1q,
    inputs: TEXTAREA_INPUTS,
    methods: ['setFocus', 'getInputElement']
  })], IonTextarea);
  return IonTextarea;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TOGGLE_INPUTS = ['checked', 'color', 'disabled', 'enableOnOffLabels', 'errorText', 'helperText', 'justify', 'labelPlacement', 'mode', 'name', 'value'];
/**
 * Pulling the provider into an object and using PURE works
 * around an ng-packagr issue that causes
 * components with multiple decorators and
 * a provider to be re-assigned. This re-assignment
 * is not supported by Webpack and causes treeshaking
 * to not work on these kinds of components.
 */
const accessorProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*@__PURE__*/forwardRef(() => IonToggle),
  multi: true
};
let IonToggle = /*#__PURE__*/(() => {
  let IonToggle = class IonToggle extends ValueAccessor {
    z;
    el;
    constructor(c, r, z, injector) {
      super(injector, r);
      this.z = z;
      c.detach();
      this.el = r.nativeElement;
      proxyOutputs(this, this.el, ['ionChange', 'ionFocus', 'ionBlur']);
    }
    writeValue(value) {
      this.elementRef.nativeElement.checked = this.lastValue = value;
      setIonicClasses(this.elementRef);
    }
    handleIonChange(el) {
      this.handleValueChange(el, el.checked);
    }
    /** @nocollapse */
    static ɵfac = function IonToggle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IonToggle)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Injector));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IonToggle,
      selectors: [["ion-toggle"]],
      hostBindings: function IonToggle_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("ionChange", function IonToggle_ionChange_HostBindingHandler($event) {
            return ctx.handleIonChange($event.target);
          });
        }
      },
      inputs: {
        checked: "checked",
        color: "color",
        disabled: "disabled",
        enableOnOffLabels: "enableOnOffLabels",
        errorText: "errorText",
        helperText: "helperText",
        justify: "justify",
        labelPlacement: "labelPlacement",
        mode: "mode",
        name: "name",
        value: "value"
      },
      features: [i0.ɵɵProvidersFeature([accessorProvider]), i0.ɵɵInheritDefinitionFeature],
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      template: function IonToggle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      encapsulation: 2,
      changeDetection: 0
    });
  };
  IonToggle = __decorate([ProxyCmp({
    defineCustomElementFn: defineCustomElement$1r,
    inputs: TOGGLE_INPUTS
  })], IonToggle);
  return IonToggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ActionSheetController, AlertController, AnimationController, GestureController, IonAccordion, IonAccordionGroup, IonActionSheet, IonAlert, IonApp, IonAvatar, IonBackButton, IonBackdrop, IonBadge, IonBreadcrumb, IonBreadcrumbs, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonChip, IonCol, IonContent, IonDatetime, IonDatetimeButton, IonFab, IonFabButton, IonFabList, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonInfiniteScroll, IonInfiniteScrollContent, IonInput, IonInputOtp, IonInputPasswordToggle, IonItem, IonItemDivider, IonItemGroup, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonList, IonListHeader, IonLoading, IonMenu, IonMenuButton, IonMenuToggle, IonModal, IonNav, IonNavLink, IonNote, IonPicker, IonPickerColumn, IonPickerColumnOption, IonPickerLegacy, IonPopover, IonProgressBar, IonRadio, IonRadioGroup, IonRange, IonRefresher, IonRefresherContent, IonReorder, IonReorderGroup, IonRippleEffect, IonRouterLink, IonRouterLinkWithHref, IonRouterOutlet, IonRow, IonSearchbar, IonSegment, IonSegmentButton, IonSegmentContent, IonSegmentView, IonSelect, IonSelectModal, IonSelectOption, IonSkeletonText, IonSpinner, IonSplitPane, IonTab, IonTabBar, IonTabButton, IonTabs, IonText, IonTextarea, IonThumbnail, IonTitle, IonToast, IonToggle, IonToolbar, LoadingController, MenuController, ModalController, PickerController, PopoverController, ToastController, provideIonicAngular };
